import { useFormState, useValidate } from '@flywire/react-hooks';
import { Button } from 'components/ui/Button/Button';
import { Heading } from 'components/ui/Heading/Heading';
import { TextInput } from 'components/ui/TextInput/TextInput';
import { useLRSContext } from 'contexts/LRS';
import { Back } from '../../components/Back/Back';
import './BankAccountNumber.scss';

export const BankAccountNumber = () => {
  const {
    complete: completeStep,
    i18n,
    navigation,
    onBack,
    updateAll: saveStepValues,
    values: savedValues,
  } = useLRSContext();
  const { bankAccountNumber, studentFullName, studentID } = savedValues;
  const { values, update, dirtyFields } = useFormState({
    ...(bankAccountNumber && { bankAccountNumber }),
    ...(studentFullName && { studentFullName }),
    ...(studentID && { studentID }),
  });

  const constraints = {
    bankAccountNumber: {
      presence: { allowEmpty: false, message: `^${i18n.t('errors.invalid')}` },
    },
    studentFullName: {
      presence: { allowEmpty: false, message: `^${i18n.t('errors.invalid')}` },
    },
    studentID: {
      presence: { allowEmpty: false, message: `^${i18n.t('errors.invalid')}` },
    },
  };

  const { isValid, errors } = useValidate(values, constraints);

  function handleOnNext() {
    saveStepValues(values);
    completeStep();
    navigation.next();
  }

  function handleTextChange(name, value) {
    update(name, value);
  }

  return (
    <div className="BankAccountNumber flex flex-col min-h-full">
      <div className="flex-1">
        <Back onClick={onBack} className="marginBottom-md" />
        <Heading as="h2" size="large" className="fontWeight-semiBold">
          {i18n.t('LRSForm.bankNumber.title')}
        </Heading>
        <div>
          <p>{i18n.t('LRSForm.bankNumber.text')}</p>
          <div className="flex flex-col gap-8">
            <TextInput
              error={
                dirtyFields.bankAccountNumber &&
                errors?.bankAccountNumber?.shift()
              }
              label={String(i18n.t('LRSForm.bankNumber.input'))}
              maxLength={18}
              name="bankAccountNumber"
              onChange={handleTextChange}
              value={values.bankAccountNumber as string}
              data-testid="bankAccountNumber"
            />
            <TextInput
              error={
                dirtyFields.studentFullName && errors?.studentFullName?.shift()
              }
              label={i18n.t('LRSForm.studentFullName.input') as string}
              name="studentFullName"
              onChange={handleTextChange}
              value={String(values.studentFullName)}
              data-testid="studentFullName"
            />
            <TextInput
              error={dirtyFields.studentID && errors?.studentID?.shift()}
              label={i18n.t('LRSForm.studentID.input') as string}
              maxLength={18}
              name="studentID"
              onChange={handleTextChange}
              value={values.studentID as string}
              data-testid="studentID"
            />
          </div>
        </div>
      </div>
      <div className="mt-auto pt-6 pb-4">
        <Button
          tone="primary"
          size="full"
          disabled={!isValid}
          onClick={handleOnNext}
          data-testid="Save"
        >
          {i18n.t('checkout.LRS.steps.save.button')}
        </Button>
      </div>
    </div>
  );
};
